import { Box, Typography, CircularProgress } from '@mui/material';
import '../../../../css/machines/MachineTotalExpense.css';

const MachineTotalExpense = ({ machineDetailsData }) => {

    function CircularProgressWithLabel({
        value,
        size = 50,
        thickness = 4,
        color = "#A97D0B",
        trackColor = "#FAE09D",
    }) {
        // For rendering, cap at 100
        const progressValue = Math.min(value, 100);

        return (
            <Box position="relative" display="inline-flex">
                {/* Background track */}
                <CircularProgress
                    variant="determinate"
                    value={100}
                    size={size}
                    thickness={thickness}
                    sx={{
                        color: trackColor,
                        position: "absolute",
                        left: 0,
                    }}
                />

                {/* Filled progress */}
                <CircularProgress
                    variant="determinate"
                    value={progressValue}
                    size={size}
                    thickness={thickness}
                    sx={{
                        color: color,
                        "& .MuiCircularProgress-circle": {
                            strokeLinecap: "round",
                        },
                    }}
                />

                {/* Percentage label */}
                <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Typography className="machineExpense_percent_label">
                        {`${Math.round(value)}%`}
                    </Typography>
                </Box>
            </Box>
        );
    }


    return (
        <Box className='machineExpense_main_box'>
            <Typography className='machineExpense_title'>Évolution des Factures</Typography>
            <Box className='machineExpense_totsl_warning_box'>
                <Box className='machineExpense_totalCount_box'>
                    <Typography className='machineExpense_unit_text'>€</Typography>
                    <Typography className='machineExpense_total_count'>{machineDetailsData?.total_expenses ? new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(machineDetailsData?.total_expenses) : '0.00'}</Typography>
                </Box>
                <Typography className='machineExpense_totsl_description_text'>Total des dépenses sur toutes les années</Typography>
                {machineDetailsData?.purchase_price &&
                    <Box className='machineExpense_warning_number_linear_box'>
                        <Box className='machineExpense_warning_main_box'>
                            <CircularProgressWithLabel className="machineExpense_CircularProgress" value={machineDetailsData?.maintenance_percentage} size={50} />
                            <Typography className='machineExpense_warning_text'>du coût de la machine ({new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(machineDetailsData?.purchase_price)})</Typography>
                        </Box>
                    </Box>
                }
            </Box>
        </Box>
    )
}

export default MachineTotalExpense